import { render, staticRenderFns } from "./CohortListFilters.vue?vue&type=template&id=2fab0bb4&"
import script from "./CohortListFilters.vue?vue&type=script&lang=js&"
export * from "./CohortListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports